import React from "react";

const CheckboxLabel = ({ label, name, handleCheckboxChange, index }) => {
  return (
    <div className="check-flex">
      <input
        type="checkbox"
        name={name}
        className="checkbox"
        onChange={() => handleCheckboxChange(index)}
      />
      <label dangerouslySetInnerHTML={{ __html: label }} htmlFor={name}></label>
    </div>
  );
};

export default CheckboxLabel;
